/**
 * OCR APIから返されるカテゴリ番号とカテゴリ名のマッピング
 */

// 大カテゴリマッピング
export const CATEGORY_MAP: Record<number, string> = {
  1: '小麦粉・雑穀粉',
  2: 'バター・乳製品・油脂・卵',
  3: 'イースト・酵母',
  4: '砂糖・はちみつ・ジャム',
  5: '塩・スパイス・ハーブ',
  6: 'チョコレート・ココア',
  7: 'ナッツ(アーモンド・くるみ等)',
  8: '栗・芋・かぼちゃ・シード',
  9: 'ドライフルーツ・野菜・果物',
  10: '精肉・肉加工品・ハム・ソーセージ',
  11: '魚介類・海産物・水産加工品',
  12: '酒・リキュール・水',
  13: '膨張剤・香料・色素・凝固剤・添加物・改良剤',
  14: '調味料',
  15: 'フィリング',
  16: 'その他',
}

// 小カテゴリマッピング
export const SUB_CATEGORY_MAP: Record<number, string> = {
  1: '小麦粉',
  2: '全粒粉',
  3: 'ライ麦',
  4: '米粉',
  5: '雑穀',
  6: 'コーンスターチ',
  7: 'ふすま粉',
  8: 'バター',
  9: '生クリーム',
  10: 'チーズ',
  11: 'マーガリン',
  12: 'ショートニング',
  13: '牛乳',
  14: 'スキムミルク(脱脂粉乳)',
  15: 'ヨーグルト',
  16: 'れん乳(コンデンスミルク・エバミルク)',
  17: '全脂粉乳',
  18: 'バターミルクパウダー',
  19: '油',
  20: '卵',
  21: 'ドライイースト',
  22: '生イースト',
  23: '酵母',
  24: '砂糖',
  25: 'はちみつ',
  26: 'シロップ',
  27: 'ジャム',
  28: 'スプレッド',
  29: '塩',
  30: 'スパイス',
  31: 'ハーブ',
  32: 'チョコレート',
  33: 'ココア・カカオ',
  34: 'アーモンド',
  35: 'くるみ・ビーカン',
  36: 'ピスタチオ・ヘーゼル',
  37: 'カシューナッツ・マカダミア',
  38: 'ココナッツ',
  39: 'その他ナッツ',
  40: '小豆',
  41: 'ごま',
  42: 'かぼちゃ',
  43: '栗',
  44: '芋',
  45: 'シード(種・実)',
  46: 'あんこ',
  47: 'ドライフルーツ',
  48: 'パウダー・フレーク・ペースト',
  49: '果汁',
  50: '漬込みフルーツ',
  51: 'フルーツピューレ',
  52: '野菜',
  53: '果物(生)',
  54: '精肉',
  55: 'ハム',
  56: 'ソーセージ',
  57: '肉加工品',
  58: '魚介類',
  59: '海産物',
  60: '水産加工品',
  61: 'ブランデー',
  62: 'ラム',
  63: 'リキュール',
  64: 'その他酒',
  65: '水',
  66: 'ベーキングパウダー・膨張剤・重曹',
  67: '香料',
  68: '色素',
  69: 'その他添加物',
  70: '凝固剤',
  71: '改良剤',
  72: 'ソース',
  73: '醤油',
  74: '味噌',
  75: 'マヨネーズ',
  76: '酢',
  77: 'マスタード・からし',
  78: 'だし',
  79: 'カレー',
  80: 'その他',
}

/**
 * カテゴリ番号をカテゴリ名に変換
 */
export const getCategoryName = (categoryNumber: number): string => {
  return CATEGORY_MAP[categoryNumber] || ''
}

/**
 * 小カテゴリ番号を小カテゴリ名に変換
 */
export const getSubCategoryName = (subCategoryNumber: number): string => {
  return SUB_CATEGORY_MAP[subCategoryNumber] || ''
}
